const Profile = () => import('@/views/Profile.vue')

export const profileList = {
    path: "/perfil",
    name: "Perfil",
    meta: { requiresAuth: true},
    component: Profile
};
